import { BaseResponse } from './base.response';

export class SubmitWarrantyClaimResponse extends BaseResponse {

  public total: number;
  public warranty: string;

}
